import { AppConfig } from "../utils/appConfig";

type NewRelicBrowserAgentOptions = {
  info: {
    applicationID: string;
    beacon: string;
    errorBeacon: string;
    licenseKey: string;
    sa: number;
  };
  init: {
    ajax: {
      deny_list: string[];
    };
    browser_consent_mode: {
      enabled: boolean;
    };
    distributed_tracing: {
      enabled: boolean;
    };
    performance: {
      capture_detail: boolean;
      capture_marks: boolean;
      capture_measures: boolean;
    };
    privacy: {
      cookies_enabled: boolean;
    };
  };
  loader_config: {
    accountID: string;
    agentID: string;
    applicationID: string;
    licenseKey: string;
    trustKey: string;
  };
};

const requireConfigValue = (value: string | undefined, fieldName: string): string => {
  if (!value?.trim()) {
    throw new Error(`Missing required value for ${fieldName}`);
  }

  return value.trim();
};

export const buildNewRelicOptions = (config: AppConfig): NewRelicBrowserAgentOptions => {
  const applicationID = requireConfigValue(
    config.new_relic_browser_application_id,
    "new_relic_browser_application_id"
  );
  const licenseKey = requireConfigValue(config.new_relic_browser_license_key, "new_relic_browser_license_key");
  const accountID = requireConfigValue(config.new_relic_browser_account_id, "new_relic_browser_account_id");
  const trustKey = requireConfigValue(config.new_relic_browser_trust_key, "new_relic_browser_trust_key");
  const agentID = requireConfigValue(config.new_relic_browser_agent_id, "new_relic_browser_agent_id");
  const beacon = requireConfigValue(config.new_relic_browser_beacon, "new_relic_browser_beacon");

  return {
    info: {
      applicationID,
      beacon,
      errorBeacon: beacon,
      licenseKey,
      sa: 1
    },
    init: {
      ajax: {
        deny_list: [beacon]
      },
      browser_consent_mode: {
        enabled: false
      },
      distributed_tracing: {
        enabled: true
      },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true
      },
      privacy: {
        cookies_enabled: true
      }
    },
    loader_config: {
      accountID,
      agentID,
      applicationID,
      licenseKey,
      trustKey
    }
  };
};
